import {
  ImpAccordion,
  ImpBadgeTextProps,
  ImpFlex,
  ImpPad,
  spacing,
} from '@imprint-payments/imprint-ui';

import { useRewardsInfo } from '../application/RewardsDisplay';

export default function RewardsModal() {
  const rewardsBonus = useRewardsInfo();

  return (
    <>
      <ImpFlex
        direction="column"
        align="center"
        justify="center"
        fluid
        dataTestId="rewards-display-body"
      >
        <ImpPad padding={spacing.l} fluid>
          <ImpFlex
            direction="column"
            align="flex-start"
            justify="center"
            fluid
            dataTestId="rewards-display-list"
            gap="s"
          >
            {rewardsBonus.map((bonus, index) => (
              <ValuePropItem {...bonus} key={index} index={index} />
            ))}
          </ImpFlex>
        </ImpPad>
      </ImpFlex>
    </>
  );
}

function ValuePropItem({
  index = 0,
  amount,
  title,
  badge,
  content,
}: {
  amount: string;
  title: string;
  content?: React.ReactNode;
  index?: number;
  badge?: ImpBadgeTextProps;
}) {
  return (
    <ImpFlex
      dataTestId={`value-prop-text-${index}`}
      align="stretch"
      direction="column"
      fluid
    >
      <ImpAccordion
        staticOpen
        items={[
          {
            badge: badge && {
              color: 'var(--merchant-color)',
              variant: 'primary',
              ...badge,
            },
            title,
            subtitle: amount,
            content: content && <ImpFlex direction="column">{content}</ImpFlex>,
          },
        ]}
      />
    </ImpFlex>
  );
}
